<template>
  <div class="flex justify-center w-full mt-20">
    <vue-loaders v-if="verifing" name="square-spin" color="#ed8936" scale=".5"></vue-loaders>
    <div v-if="!verifing && linkRevoked" class="flex flex-col items-center">
      <span class="mb-8 text-2xl font-bold">Il link usato non è più valido</span>
      <p class="text-lg text-center opacity-75 " :style="{ maxWidth: '64ch' }">
        Per proteggere al meglio i tuoi dati i link che danno accesso a informazioni sensibili
        possono essere utilizzati sono una volta.
        <br />
        Richiedi un altro link per accedere.
      </p>
      <router-link to="/" class="mt-8 text-i4m-orange">Torna alla pagina iniziale</router-link>
    </div>
  </div>
</template>

<script>
import api from '@/api';

export default {
  name: 'OrderAuthVerify',

  data() {
    return {
      token: null,
      verifing: true,
      linkRevoked: false,
      redirect_to: null
    };
  },

  beforeMount() {
    this.token = this.$route.query.order_email_token;
    this.redirect_to = this.$route.query.redirect_to;
    this.with_order_token = this.$route.query.with_order_token;
    if (!this.token) {
      this.$router.replace({ name: 'home' });
      return;
    }
    // clean the token from the url
    this.$router.replace({ name: 'auth-order' });
  },

  async mounted() {
    try {
      const resp = await api.verifyEmailToken(this.token, {
        withOrderToken: this.with_order_token
      });
      const order = resp.data;
      this.$store.commit('setGettingOrder', false);
      this.$store.commit('setActiveOrder', order);

      // // se gli ordini sono uguali tengo solo quello autenticato e faccio il reset di quello in corso
      // if (this.$store.state.order && this.$store.state.order.code == order.code) {
      //   await api.resetOrder();
      //   this.$store.commit('setOrder', null);
      // }

      if (this.with_order_token) {
        this.$store.commit('setOrder', order);
      } else {
        this.$store.commit('setAuthOrder', order);
      }

      if (this.redirect_to) {
        return this.$router.replace(this.redirect_to);
      }

      this.$router.push({ name: 'order' });
    } catch (e) {
      console.log('Error while verifing auth order token');
      console.log(e);

      if (e.response.status === 401) {
        this.linkRevoked = true;
      }

      if (e.response.status === 404) {
        this.$router.push('/not_found');
      }
    }

    this.verifing = false;
  }
};
</script>

<style lang="css" scoped></style>
